import React, { useContext, useState } from 'react';
import { Joyride, STATUS } from 'react-joyride';
import { useTranslation } from 'react-i18next';
import AuthContext from '../context/AuthContext';
import { isSeen, markSeen } from '../utils/onboardingSeen';

const GUIDE_KEY = 'subscribe_plans_guide';

const FIELDS = [
    {
        target: '#onboarding-payment-method-toggle',
        titleKey: 'onboardingTour.subscribeGuide.paymentMethod.title',
        contentKey: 'onboardingTour.subscribeGuide.paymentMethod.content',
    },
    {
        target: '#onboarding-plans-section',
        titleKey: 'onboardingTour.subscribeGuide.plans.title',
        contentKey: 'onboardingTour.subscribeGuide.plans.content',
    },
];

/**
 * Guía de 2 pasos en /settings/plan, solo mientras el negocio no tenga una suscripción
 * activa: (1) el selector de método de pago (tarjeta vs PSE/Nequi), (2) las tarjetas de
 * planes. Análoga a BusinessSetupGuide.js.
 */
const SubscribePlanGuide = () => {
    const { user, business } = useContext(AuthContext);
    const { t } = useTranslation();
    const [dismissed, setDismissed] = useState(false);

    const isSubscriptionActive = ['active', 'trialing'].includes(business?.subscription_status);
    const shouldRun = !!user && user.role === 'owner' && !isSubscriptionActive
        && !dismissed && !isSeen(user.id, GUIDE_KEY);

    if (!shouldRun) return null;

    const steps = FIELDS.map((field) => ({
        target: field.target,
        content: (
            <div>
                <strong>{t(field.titleKey)}</strong>
                <p className="mb-0 mt-1">{t(field.contentKey)}</p>
            </div>
        ),
        // v3 no tiene disableBeacon (gotcha de la tarea 030) — skipBeacon abre el tooltip
        // directo, sin esperar un clic en el beacon.
        skipBeacon: true,
        placement: 'bottom',
    }));

    const handleCallback = (data) => {
        if (data.status === STATUS.FINISHED || data.status === STATUS.SKIPPED) {
            markSeen(user.id, GUIDE_KEY);
            setDismissed(true);
        }
    };

    return (
        <Joyride
            steps={steps}
            run
            continuous
            showProgress
            showSkipButton
            locale={{
                back: t('common.back'),
                next: t('common.next'),
                last: t('common.finish'),
                close: t('common.gotIt'),
                skip: t('common.skip'),
            }}
            styles={{ options: { primaryColor: '#0d6efd', zIndex: 10000 } }}
            callback={handleCallback}
        />
    );
};

export default SubscribePlanGuide;
